import httpClient from './httpClient';

export const getGoogleCalendarAuthUrl = async () => {
  const { data } = await httpClient.get('/google-calendar/auth-url');
  return data;
};

export const connectGoogleCalendar = async (code) => {
  const { data } = await httpClient.post('/google-calendar/connect', { code });
  return data;
};

export const getGoogleCalendarStatus = async () => {
  const { data } = await httpClient.get('/google-calendar/status');
  return data;
};

export const disconnectGoogleCalendar = async () => {
  const { data } = await httpClient.post('/google-calendar/disconnect');
  return data;
};
